import { ConversationSummary } from "@ac-expo/api-types";
import { formatTimeDifference, getRoleLabel } from "@ac-expo/utils";
import { cn } from "../../../utils";
import { Archive } from "@phosphor-icons/react";
import { ButtonWithConfirm } from "../ButtonWithConfirm";

type ConversationListItemProps = ConversationSummary & {
  active?: boolean;
  pictureUrl?: string;
  archive: (conversationId: string) => void;
};

export function ConversationsListItem({
  id,
  lastMessage,
  with: participant,
  active,
  pictureUrl,
  archive,
}: ConversationListItemProps) {
  return (
    <div
      className={cn(
        "border-b p-4",
        active && "border-r-[5px] border-r-blue-500 bg-blue-50"
      )}
    >
      <div className="flex gap-4">
        <img
          src={pictureUrl ? pictureUrl : "/images/anonymous_avatar.svg"}
          alt="profile"
          className="aspect-square size-10 rounded-full"
        />
        <div className="flex w-full flex-col gap-1">
          <div className="flex w-full items-center justify-between">
            <p className="text-sm font-bold">
              {participant.firstName} {participant.lastName}
            </p>
            <p
              className={cn(
                "w-min rounded-full border px-2 text-xs font-semibold",
                {
                  "bg-blue-500 text-white": !lastMessage?.isRead,
                  "bg-white text-black": lastMessage?.isRead,
                }
              )}
            >
              {formatTimeDifference(lastMessage?.sentAt)}
            </p>
          </div>
          <div className="flex justify-between">
            <div className="flex flex-1 flex-col gap-1">
              <div className="no-scrollbar mr-4 flex flex-wrap gap-1 overflow-hidden">
                {participant.roles &&
                  participant.roles.map(
                    (roleObject: { role: string }, index) => (
                      <p
                        key={index}
                        className="min-w-max overflow-hidden whitespace-nowrap rounded-full border bg-white px-2 text-xs"
                      >
                        {getRoleLabel(roleObject.role)}
                      </p>
                    )
                  )}
              </div>
              <p className="text-left text-xs">
                {(lastMessage?.content.substring(0, 45) ?? "") + "..."}
              </p>
            </div>
            {archive !== undefined ? (
              <ButtonWithConfirm
                variant="null"
                confirmText="Voulez-vous archiver cette conversation ?"
                className="px-1"
                onClick={() => archive(id)}
              >
                <Archive size={22} className="text-amber-600" />
              </ButtonWithConfirm>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
